import { useEffect, useState } from 'react'

/**
 * **분 단위로 「지금」을 다시 읽는다** — 경과 표기(「3분 경과」)가 멈춰 있지 않게.
 *
 * 🔴 **폴링이 아니다**(DP-01). 서버에 아무것도 묻지 않는다 — 시계만 다시 읽는다.
 *    금지된 것은 「주기적으로 서버 상태를 다시 조회하는 것」이고, 이건 **뺄셈의 왼쪽 항**이다.
 * 🔴 **초 단위로 돌리지 않는다.** 화면이 적는 값이 분 해상도(「3분 경과」)라 더 자주 돌아도
 *    보이는 글자가 안 바뀐다 — 카드 수십 장을 1초마다 다시 그릴 까닭이 없다.
 * 🔴 **경과를 여기서 계산하지 않는다.** 이 훅은 「지금」만 낸다. 뺄셈은 `elapsedSec()` 이 하고
 *    시험은 그 순수 함수에 `now` 를 먹여 잰다.
 */
const MINUTE_MS = 60_000

export function useMinuteTick(): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const id = setInterval(() => {
      setNow(Date.now())
    }, MINUTE_MS)
    return () => {
      clearInterval(id)
    }
  }, [])

  return now
}
